import { Box, Button, Typography } from '@mui/material';
import EditIcon from '@treyd-io/treyd-ui/icons/EditIcon';
import { useTranslation } from 'react-i18next';

interface Props {
  title: string;
  onEditClick: () => void;
}

export const SectionHeader = (props: Props) => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap">
      <Typography variant="subtitle1" color="text.primary">
        {props.title}
      </Typography>
      <Button
        type="button"
        variant="text"
        size="small"
        color="info"
        startIcon={<EditIcon />}
        onClick={props.onEditClick}>
        {t('edit')}
      </Button>
    </Box>
  );
};
